/* same-day-delivery.js
   Keeps the product-page same-day badge in sync with the quantity selector:
   when (selected quantity + quantity already in the cart) exceeds the
   local-delivery stock passed via data-available, the green banner is
   swapped for the "quantity not available for same-day delivery" warning.
   Without data-available (no stock data synced yet) the badge stays static.
   The badge is re-rendered inside the price node on variant change, so
   connectedCallback re-runs with that variant's fresh data. */

/* Cart mode: mirror the server-computed verdict into the same_day_status
   cart attribute so checkout apps (Checkout Blocks) can condition on it.
   Posts only when the stored attribute differs from the fresh verdict;
   an empty status clears the attribute. */
if (!customElements.get('same-day-cart-attribute')) {
  customElements.define(
    'same-day-cart-attribute',
    class SameDayCartAttribute extends HTMLElement {
      connectedCallback() {
        const status = this.dataset.status || '';
        const current = this.dataset.current || '';
        if (status === current || window.__sameDayStatusWritten === status) return;
        window.__sameDayStatusWritten = status;
        const url = (window.routes && window.routes.cart_update_url) || '/cart/update.js';
        fetch(url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: { same_day_status: status } }),
        }).catch(() => {
          window.__sameDayStatusWritten = undefined;
        });
      }
    }
  );
}

if (!customElements.get('same-day-delivery-badge')) {
  customElements.define(
    'same-day-delivery-badge',
    class SameDayDeliveryBadge extends HTMLElement {
      connectedCallback() {
        this.okBanner = this.querySelector('.same-day-banner:not(.same-day-banner--warning)');
        this.warnBanner = this.querySelector('.same-day-banner--warning');
        if (!this.okBanner || this.dataset.available === undefined) return;
        this.available = parseInt(this.dataset.available, 10) || 0;
        this.scope = this.closest('product-info') || document;
        this.abortController = new AbortController();
        ['change', 'input'].forEach((eventName) =>
          this.scope.addEventListener(
            eventName,
            (event) => {
              if (event.target.name === 'quantity') this.update();
            },
            { signal: this.abortController.signal }
          )
        );
        this.update();
      }

      disconnectedCallback() {
        this.abortController?.abort();
      }

      update() {
        const input = this.scope.querySelector('input[name="quantity"]');
        if (!input) return;
        const selected = parseInt(input.value, 10) || parseInt(input.min, 10) || 1;
        const inCart = parseInt(input.dataset.cartQuantity, 10) || 0;
        const exceeded = this.available < selected + inCart;
        this.okBanner.hidden = exceeded;
        if (this.warnBanner) this.warnBanner.hidden = !exceeded;
      }
    }
  );
}
